import {Component, OnInit} from '@angular/core';
import {MomentPipe} from "../../shared/moment.pipe";

@Component({
  selector: 'app-external-completed',
  templateUrl: './external-completed.component.html',
  styleUrls: ['./external-completed.component.css']
})
export class ExternalCompletedComponent implements OnInit {
   lastModified: any;
   taskAttribute;

   ngOnInit(): void {
      const fmt = new MomentPipe();
      this.lastModified = {when: fmt.transform(Date.now())};
      this.taskAttribute = {
         docName : 'external-sign'
      }
   }
}
